import {gql} from '@apollo/client/core';

export const GetPwpProfile = gql`
    query getPwpProfile($subdomain: String!) {
        getPwpProfile(subdomain: $subdomain) {
            subdomain
            country
            websiteId
            params {
                key
                param
                value
                visible
            }
        }
    }
`;
